import { useCallback } from 'react';

import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';

import { useCancelJobMutation } from '../../graphql/mutations/generated/cancelJob';

const useCancelJob = () => {
  const [, cancelJob] = useCancelJobMutation();

  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();

  const onCancelJob = useCallback(
    async (jobScheduleId: string) => {
      const res = await cancelJob({ input: { jobScheduleId } });
      if (res.error) {
        showDefaultErrorSnackbar();
      }

      return res;
    },
    [cancelJob, showDefaultErrorSnackbar],
  );

  return { onCancelJob };
};

export default useCancelJob;
